import React, { useEffect, useMemo } from "react";
import { FileReaderHandler } from "./functions/FileReaderHandler";
import Previewer from "./components/Previewer";
import PreviewerChip from "./components/PreviewerChip";

const PicutreDropField = ({ placeholder, UiValue = null, onChange }) => {
  const [fileReaderContent, setFileReaderContent] = React.useState({
    fileName: "",
    fileContent: "",
  });
  const fileInputRef = React.useRef(null);
  React.useEffect(() => {
    if (fileReaderContent?.fileName.length !== 0) {
      onChange(fileReaderContent?.fileContent);
    }
  }, [fileReaderContent]);
  const memoUiValue = useMemo(() => UiValue, [JSON.stringify(UiValue)]);
  useEffect(() => {
    if (memoUiValue) {
      setFileReaderContent({
        fileName: "Logo",
        fileContent: UiValue,
      });
    }
  }, [memoUiValue]);
  return (
    <React.Fragment>
      <Previewer fileInputRef={fileInputRef}>
        <input
          onChange={(event) => FileReaderHandler(event, setFileReaderContent)}
          type="file"
          accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
          hidden
          ref={fileInputRef}
        />
        <p>{placeholder}</p>
        <PreviewerChip
          fileReaderContent={fileReaderContent}
          setFileReaderContent={setFileReaderContent}
          onChange={onChange}
        />
      </Previewer>
    </React.Fragment>
  );
};

export default PicutreDropField;
